<div class="payment-spinner" *ngIf="spinnerVisible">
  <span class="spinner-text" translate>PROCESSING</span>
  <div class="loading">
    <div class="spin-circle"></div>
  </div>
</div>
